module.exports = __webpack_public_path__ + "019c53decd98372a2cc38e6506fbba07.svg";